import Loader from 'src/components/Loader'

function ActiveSCLoader() {
  return (
    <div style={{ marginTop: 30 }}>
      <Loader />
    </div>
  )
}

export default ActiveSCLoader
